/** @format */

import React from 'react'
import { IconProps } from './index'

const Session: React.FC<IconProps> = ({
  className,
  width = 14,
  height = 14,
  color = '#848f9a'
}) => {
  return (
    <svg
      className={`icon ${className}`}
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9133"
    >
      <path
        // eslint-disable-next-line max-len
        d="M616.704 167.8848a50.2784 50.2784 0 0 0 18.7904-3.6864 46.592 46.592 0 0 0 15.872-10.5984 52.2752 52.2752 0 0 0 10.6496-15.9232 47.872 47.872 0 0 0 3.7376-18.7392 47.3088 47.3088 0 0 0-3.7376-18.688 50.0224 50.0224 0 0 0-26.5728-26.5728 48.0768 48.0768 0 0 0-18.688-3.6864H309.9648A309.9648 309.9648 0 0 0 0 379.904v334.2336a309.9648 309.9648 0 0 0 310.016 309.9136h687.104a79.6672 79.6672 0 0 0 79.616-79.5648v-426.1376a47.616 47.616 0 0 0-14.3872-34.6112 45.7216 45.7216 0 0 0-15.872-10.752 52.9408 52.9408 0 0 0-18.7392-3.6352 50.8416 50.8416 0 0 0-18.7392 3.7376 47.104 47.104 0 0 0-15.872 10.5984 49.4592 49.4592 0 0 0-13.4144 25.0368 50.688 50.688 0 0 0-0.9216 9.6256v407.6544H310.0672a211.8144 211.8144 0 0 1-212.0192-211.8656V379.904a211.9168 211.9168 0 0 1 212.0192-211.9168h306.6368z"
        p-id="7780"
        fill="#1890ff"
      ></path>
      <path
        // eslint-disable-next-line max-len
        d="M351.488 422.2464a53.1968 53.1968 0 0 1 60.2112 60.2112v146.9952a60.2112 60.2112 0 1 1-120.4224 0V482.4576a53.1968 53.1968 0 0 1 60.2112-60.2112z m334.5408 0a53.248 53.248 0 0 1 60.2112 60.2112v146.9952a60.2112 60.2112 0 1 1-120.4224 0V482.4576a53.1968 53.1968 0 0 1 60.16-60.2112z m54.1184-232.2944a18.7392 18.7392 0 0 0 0 36.352l78.2336 19.1488a107.0592 107.0592 0 0 1 78.2848 78.2848l19.2512 78.2848a18.7392 18.7392 0 0 0 36.352 0l19.2512-78.2848a107.008 107.008 0 0 1 78.336-78.2848l78.1312-19.2512a18.7392 18.7392 0 0 0 0-36.352l-78.1312-19.3024a107.0592 107.0592 0 0 1-78.2848-78.2848L952.32 14.1824a18.7904 18.7904 0 0 0-36.4032 0l-19.2512 78.1312a107.0592 107.0592 0 0 1-78.2848 78.2848l-78.2848 19.2z"
        p-id="7781"
        fill="#1890ff"
      ></path>
    </svg>
  )
}

export default Session
